import React, { Component } from "react";
import TabelaEmpresas from "./TabelaEmpresas";

class Aprovados extends Component {
  render() {
    return <TabelaEmpresas dados={this.props.payload} mostrarAcoes={false} />;
  }
}

export default Aprovados;
